module.exports = __webpack_public_path__ + "img/sbg0103.e4b9df09.png";